import {
  ACTION_GET_ORG_EXPENSES,
  ACTION_GET_ORG_EXPENSES_SUCCESS,
  ACTION_GET_ORG_EXPENSES_FAILURE,
  ACTION_GET_MORE_ORG_EXPENSES,
  ACTION_GET_MORE_ORG_EXPENSES_SUCCESS,
  ACTION_GET_MORE_ORG_EXPENSES_FAILURE,
  ACTION_EMPTY_ORG_EXPENSES,
  API_CALL,
} from '../../configs/ActionTypes';

import { Dispatch } from 'redux';

import { enqueueSnackbarHandler } from '../Status';

export interface OrgExpensesParams {
  limit?: number;
  syncToGlStatus?: string;
  dateFrom?: string;
  dateTo?: string;
}

export function getOrgExpenses(organizationId: string, params?: OrgExpensesParams) {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch({ type: ACTION_GET_ORG_EXPENSES, payload: null });

    dispatch({
      type: API_CALL,
      payload: {
        call: `organizations/${organizationId}/expenses`,
        method: 'get',
        data: params || {},
        success: (response: any) => {
          dispatch({ type: ACTION_GET_ORG_EXPENSES_SUCCESS, payload: response });
        },
        fail: (error: any) => {
          enqueueSnackbarHandler(dispatch, error.payload, 'error');
          dispatch({ type: ACTION_GET_ORG_EXPENSES_FAILURE, payload: error });
        },
      },
    });
  };
}

export function getMoreOrgExpenses(
  organizationId: string,
  params: OrgExpensesParams,
  cursor: { id: string; created: string },
) {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch({ type: ACTION_GET_MORE_ORG_EXPENSES, payload: null });

    dispatch({
      type: API_CALL,
      payload: {
        call: `organizations/${organizationId}/expenses`,
        method: 'get',
        data: {
          ...params,
          'cursor[id]': cursor.id,
          'cursor[created]': cursor.created,
        },
        success: (response: any) => {
          dispatch({ type: ACTION_GET_MORE_ORG_EXPENSES_SUCCESS, payload: response });
        },
        fail: (error: any) => {
          enqueueSnackbarHandler(dispatch, error.payload, 'error');
          dispatch({ type: ACTION_GET_MORE_ORG_EXPENSES_FAILURE, payload: error });
        },
      },
    });
  };
}

export const emptyOrgExpenses = () => ({ type: ACTION_EMPTY_ORG_EXPENSES, payload: null });

